/*
 * The closing beat.
 *
 * Deliberately the simplest scene on the page: the reusable text reveal, and an
 * illustration that keeps moving after it has arrived. A video loops on its own;
 * a still image gets a slow idle float so the page doesn't end on something
 * completely static.
 */
import {
	defineScene,
	revealText,
	riseIn,
	slideInFromRight,
	reducedMotion,
	enterConfig,
} from '@theme/about-story';

defineScene('about-closing', (root, gsap) => {
	const heading = root.querySelector('[data-about-heading]');
	const rising = root.querySelectorAll('[data-about-rise]');
	const figure = root.querySelector('[data-about-figure]');

	const timeline = gsap.timeline({
		...enterConfig(heading ?? root),
	});


	if (figure) slideInFromRight(figure, { timeline, position: 0.15, distance: -160, xPercent: -8 });
	if (heading) revealText(heading, { timeline, position: 0.15 });
	if (rising.length) riseIn(rising, { timeline, position: heading ? '>' : 0.15 });

	const wantsLoop = root.dataset.loop === 'true';
	const still = figure?.querySelector('img');

	if (!wantsLoop || !still || reducedMotion()) return;

	timeline.to(
		still,
		{ y: -14, duration: 2.4, ease: 'sine.inOut', repeat: -1, yoyo: true },
		'>-0.2'
	);
});
